import type { KeyboardEvent } from 'react'

/**
 * Restricts keyboard input to numeric characters and a single decimal point.
 * Allows navigation keys (arrows, Home, End), editing keys (Backspace, Delete, Tab),
 * and clipboard shortcuts (Ctrl/Cmd+C/V/X/A).
 */
export function numericOnly(e: KeyboardEvent<HTMLInputElement>) {
  if (e.ctrlKey || e.metaKey) return
  if (e.key.length > 1) return              // allow all special keys (Backspace, Arrow*, Tab, etc.)
  if (/[0-9]/.test(e.key)) return            // digits
  if ((e.key === '.' || e.key === ',') && !e.currentTarget.value.includes('.') && !e.currentTarget.value.includes(',')) return // single dot/comma
  e.preventDefault()
}

export function numericAndNegativeOnly(e: KeyboardEvent<HTMLInputElement>) {
  if (e.ctrlKey || e.metaKey) return
  if (e.key.length > 1) return              // allow all special keys (Backspace, Arrow*, Tab, etc.)
  if (/[0-9]/.test(e.key)) return            // digits
  if (e.key === '-' && e.currentTarget.selectionStart === 0 && !e.currentTarget.value.includes('-')) return // negative sign at start
  if ((e.key === '.' || e.key === ',') && !e.currentTarget.value.includes('.') && !e.currentTarget.value.includes(',')) return // single dot/comma
  e.preventDefault()
}
